import {  } from "config";
import { MAIN_ROLES, DASHBOARD_PATH } from "config";
import { useAuth } from "context/AuthContext";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";


export function usePermissionRedirect() {
    const { user } = useAuth();
    const navigate = useNavigate();

    const handleLogoClick = useCallback(() => {
        const hasRoleCheck = () => MAIN_ROLES?.filter(name => user?.rolesName?.includes(name))?.length;
        if (hasRoleCheck()) {
            navigate(DASHBOARD_PATH, { replace: true });
        } else {
            navigate('/projects/project-creation/project-list', { replace: true });
        }
    }, [user, navigate]);

    return handleLogoClick;
}
